import FlexiText from "slotworks/graphics/elements/flexi-text";
import Layers from "slotworks/graphics/layers/layers";
import Timer from "slotworks/utils/timer";

export default class ClockComponent {
    private clockText: FlexiText;

    private timer: number;

    constructor(displayClock: boolean = true) {
        this.clockText = Layers.Header.getFlexiText("clock");
        this.clockText.setVisible(displayClock);

        if (this.clockText != null && displayClock) {
            const millisecondsLeft = 60000 - new Date().getSeconds() * 1000;
            this.updateClock(millisecondsLeft);
        }
    }

    public destroy() {
        Timer.clearTimeout(this.timer);
    }

    private updateClock(milliseconds: number = 60000) {
        this.clockText.setText(this.getTime());

        this.timer = Timer.setTimeout(() => {
            this.updateClock();
        }, milliseconds);
    }

    private getTime() {
        const today = new Date();
        const hours = today.getHours();
        const minutes = today.getMinutes();

        return this.leadZeroes(hours) + ":" + this.leadZeroes(minutes);
    }

    private leadZeroes(n: number) {
        if (n < 10) {
            return "0" + n.toString();
        } else {
            return n.toString();
        }
    }
}
